import styled from '@emotion/styled';
import {
  ButtonGhost as CommonButtonGhost,
  IconButtonGhost as CommonIconButtonGhost,
  Tooltip,
} from '@kc-console/common-ui';

import type { ButtonGhostProps, IconButtonGhostProps, TooltipProps } from '@kc-console/common-ui';

type TooltipServiceButtonProps = Omit<ButtonGhostProps, 'variant' | 'size'> &
  Pick<TooltipProps, 'message'>;

export const TooltipServiceButton = ({ message, ...buttonProps }: TooltipServiceButtonProps) => {
  return (
    <Tooltip message={message}>
      <TooltipServiceButtonStyle variant="inverse" size="sm" {...buttonProps} />
    </Tooltip>
  );
};

export const ServiceButton = (buttonProps: Omit<ButtonGhostProps, 'variant' | 'size'>) => {
  return <TooltipServiceButtonStyle variant="inverse" size="sm" {...buttonProps} />;
};

const TooltipServiceButtonStyle = styled(CommonButtonGhost)`
  padding: 11px 8px;
  height: 40px;

  > span:first-of-type {
    margin-right: 4px;
  }

  :hover {
    background-color: ${({ theme }) => theme.color['surface/global/transparent/weakest/hover']};
  }

  :active {
    background-color: ${({ theme }) => theme.color['surface/global/transparent/weakest/press']};
  }

  ${({ theme }) => theme.mixins.focusRing('inside', { inverse: true })}
`;

type TooltipIconServiceButtonProps = Omit<IconButtonGhostProps, 'variant' | 'size'> &
  Pick<TooltipProps, 'message'>;

export const TooltipIconServiceButton = ({
  message,
  ...buttonProps
}: TooltipIconServiceButtonProps) => {
  return (
    <Tooltip message={message}>
      <IconServiceButtonStyle variant="inverse" size="md" {...buttonProps} />
    </Tooltip>
  );
};

export const IconServiceButton = (buttonProps: Omit<IconButtonGhostProps, 'variant' | 'size'>) => {
  return <IconServiceButtonStyle variant="inverse" size="md" {...buttonProps} />;
};

const IconServiceButtonStyle = styled(CommonIconButtonGhost)`
  height: 40px;

  :hover {
    background-color: ${({ theme }) => theme.color['surface/global/transparent/weakest/hover']};
  }

  :active {
    background-color: ${({ theme }) => theme.color['surface/global/transparent/weakest/press']};
  }

  ${({ theme }) => theme.mixins.focusRing('inside', { inverse: true })}
`;
